import {combineReducers} from 'redux';
import * as a from './actionTypes'

function appUiMessages(state = [], action) {
  switch (action.type) {
    case a.APP_UI_MSGS:
      return action.data;
    default:
      return state;
  }
}

function appsList(state = [], action) {
  switch (action.type) {
    case a.ALL_SSO_APPS_RECEIVED:
      return action.data;
    default:
      return state;
  }
}

function coreAppsList(state = [], action) {
  switch (action.type) {
    case a.SSO_APPS_CORE_APPS:
      return action.data;
    default:
      return state;
  }
}

function loginAppsList(state = [], action) {
  switch (action.type) {
    case a.SSO_APPS_LOGIN_APPS:
      return action.data;
    default:
      return state;
  }
}

export default combineReducers(
    {
      appsList,
      appUiMessages,
      coreAppsList,
      loginAppsList
    }
)
